export function copyDirective(app) {
	app.directive("copy", {
		// 在绑定元素的 attribute 前
		// 或事件监听器应用前调用
		created(el, binding, vnode, prevVnode) {
			// 下面会介绍各个参数的细节
		},
		// 在元素被插入到 DOM 前调用
		beforeMount(el, binding, vnode, prevVnode) {},
		// 在绑定元素的父组件
		// 及他自己的所有子节点都挂载完成后调用
		mounted(el, binding, vnode, prevVnode) {
			const { value } = binding;
			el.$value = value;
			el.handler = () => {
				if (!el.$value) return;
				// 动态创建 textarea 标签
				const textarea = document.createElement("textarea");
				// 将该 textarea 设为 readonly 防止 iOS 下自动唤起键盘，同时将 textarea 移出可视区域
				textarea.readOnly = "readonly";
				textarea.style.position = "absolute";
				textarea.style.left = "-9999px";
				// 将要 copy 的值赋给 textarea 标签的 value 属性
				textarea.value = el.$value;
				// 将 textarea 插入到 body 中
				document.body.appendChild(textarea);
				// 选中值并复制
				textarea.select();
				// textarea.setSelectionRange(0, textarea.value.length);
				const result = document.execCommand("Copy");
				if (result) {
					ElMessage({
						message: "复制成功",
						grouping: true,
						type: "success"
					});
				}
				document.body.removeChild(textarea);
			};
			// 绑定点击事件，就是所谓的一键 copy 啦
			el.addEventListener("click", el.handler);
		},
		// 绑定元素的父组件更新前调用
		beforeUpdate(el, binding, vnode, prevVnode) {},
		// 在绑定元素的父组件
		// 及他自己的所有子节点都更新后调用
		updated(el, binding, vnode, prevVnode) {
			const { value } = binding;
			el.$value = value;
		},
		// 绑定元素的父组件卸载前调用
		beforeUnmount(el, binding, vnode, prevVnode) {},
		// 绑定元素的父组件卸载后调用
		unmounted(el, binding, vnode, prevVnode) {
			el.removeEventListener("click", el.handler);
		}
	});
}
